import React from 'react';
import {
    getColor,
    colorRange,
    districtColorRange,
    getDistrictColor,
    palikaColorRange,
    getPalikaColor
} from '../../utils/helpers';

const PoPresenceLegend = ({ isMainDashboard, isDistrictLevel, isPalikaLevel, title }) => {
    let colors, colorFunc;

    if(isPalikaLevel){
        colors = palikaColorRange;
        colorFunc =  getPalikaColor;
    }   else {
        colors = isDistrictLevel ? districtColorRange : colorRange;
        colorFunc =  isDistrictLevel ? getDistrictColor : getColor;
    }

    const wrapperStyle = {
        color: "#000",
        position: "absolute",
        right: isMainDashboard || isPalikaLevel ? "15px" : "25px",
        top: isMainDashboard || isPalikaLevel ? "60px" : "20px",
        padding: "6px",
        background: "rgb(232, 229, 229)",
        opacity: ".7"
    };
    const legendItemStyle = {
        display: "inline-block",
        marginRight: "10px"
    };
    const legendTextStyle = {
        textAlign: "center",
        fontSize: "10px"
    };

    return (
        <div className="color-legend" style={wrapperStyle}>
            <h4>{title && title.length > 0 ? title : "Number of POs present"}</h4>
            <div className="legend-item-wrapper">
                {colors &&
                colors.map(type => (
                    <div className="legend-item"  style={legendItemStyle}>
                        <div className="legend-text" style={legendTextStyle}>
                            {type.min === 0 && !type.max
                            ? type.min
                            : `${type.min} - ${type.max}`}
                        </div>
                        <div
                            className="color-part"
                            style={{
                                backgroundColor: `${colorFunc(type.min)}`,
                                width: "20px",
                                margin: "0 5px",
                                height: "20px",
                                border: "1px solid"
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PoPresenceLegend;